import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { CatalogCurrencyLabel } from 'Shared/CurrencyLabel'

import ReactImageFallback from 'react-image-fallback'
import imagefallback from '@loyal_images/products/product_placeholder.png'

const CartItem = props => (
  <Link to={`/products/${props.sku}`} className='cart-item row mx-0'>
    <div className='cart-img px-0 col-auto txt-center'>
      <ReactImageFallback
        src={props.imageUrl}
        fallbackImage={imagefallback}
        initialImage={imagefallback}
        className='img-w-auto'
        alt=''
      />
    </div>
    <div className='cart-product-info col'>
      <div className='cart-product-info row'>
        <div className='product-infos col-12 mx-0'>
          <h2 className='txt-body-sm txt-font-body color-ui-2 '>
            {props.name}
          </h2>
        </div>
      </div>
      <div className='row card-price-item pt-half'>
        <div className='card-price-points col-12 txt-body txt-circular-black txt-left color-title'>
          <CatalogCurrencyLabel
            price={{
              points: props.price,
              cash: (props.cash && props.cash.sellingPrice) || 0
            }}
            checkCashOnly
          />
        </div>
      </div>
      <div className='row product-quantity pt-half'>
        <div className='col-12'>
          <p className='txt-font-body color-ui-2 txt-left  justify-content-center align-self-center'>
            Quantidade: <strong>{props.quantity}</strong>
          </p>
        </div>
      </div>
    </div>
  </Link>
)

CartItem.propTypes = {
  imageUrl: PropTypes.string,
  cash: PropTypes.object,
  quantity: PropTypes.number,
  name: PropTypes.string,
  price: PropTypes.number,
  sku: PropTypes.string
}

export default CartItem



// WEBPACK FOOTER //
// ./src/App/Header/Cart/CartItem/CartItem.js